import React, { SelectHTMLAttributes } from 'react';

import { Container, Selected, Option } from './styles';
import { FaCaretDown } from 'react-icons/fa';
import { Hours } from './hours';
import moment from 'moment';
import { useSelector } from 'react-redux';
interface SelectProps extends SelectHTMLAttributes<HTMLSelectElement> {
  name: string;
  date: Date;
}

const Select: React.FC<SelectProps> = ({ name, date, ...rest }) => {
  const config = useSelector((state: ApplicationState) => {
    return state.config;
  });

  const startHour =
    moment(date).day() === 6
      ? config.startSaturdayAttendance
      : config.startBusinessDayAttendance;
  const endHour =
    moment(date).day() === 6
      ? config.endSaturdayAttendance
      : config.endBusinessDayAttendance;

  return (
    <Container>
      <Selected value='' id={name} {...rest}>
        <Option value='' disabled hidden>
          Selecione
        </Option>
        {Hours(startHour, endHour, moment().isSame(date, 'day')).map(
          (data, index) => {
            return (
              <Option key={index} value={data}>
                {data}
              </Option>
            );
          }
        )}
      </Selected>
      <FaCaretDown
        style={{ pointerEvents: 'none' }}
        size={16}
        color={'#7B86A3'}
      />
    </Container>
  );
};

export default Select;
